export const PERMISSION_ABOUT = "app-uniksystem-menu-about";
export const PERMISSION_TOOLS = "app-uniksystem-menu-tools";
export const PERMISSION_BPM_ADMIN = "app-bpm-menu-admin";
